import { createClient } from "@supabase/supabase-js";
import { authenticatedHeadersHash, accessToken, anonToken } from "views_shared/app/javascript/scripts/authentication";

// https://github.com/supabase/supabase-js/issues/514#issuecomment-1218513303
const supabaseClient = createClient(globalThis.Qwoted.SUPABASE_API_EXTERNAL_URL, anonToken(), {
  db: {
    schema: globalThis.Qwoted.POSTGREST_API_SCHEMA,
  },
  auth: {
    autoRefreshToken: false,
    detectSessionInUrl: false,
    persistSession: false,
  },
  global: {
    headers: authenticatedHeadersHash(),
  },
});
supabaseClient.realtime.setAuth(accessToken());
globalThis.Qwoted.supabaseClient = supabaseClient;
